import type { FormOptions } from '@customTypes/types';

export const helpWithOptions: FormOptions = {
  flexHybrydObservability: 'HPE GreenLake Flex or Hybrid Observability',
  standaloneSaaS: 'Standalone SaaS',
  unknown: 'Unknown',
};
